import React, {Component} from 'react';
import {connect} from 'react-redux';
import api from '../../../util/api';
import log from '../../../util/log';
import c from '../../../util/const';
import { getMessageForError } from "../../../util/errors";

import { validateEmail } from '../../../util/validation';

import FancyInput from '../elements/FancyInput';
import PulseButton from '../elements/PulseButton';
import Button from '../elements/Button';

import authActions from "../../../actions/auth-actions";
import Loading from "../util/Loading";
import PropTypes from "prop-types";
import {withTranslation} from "react-i18next";
import {withVFTranslation} from "../../../util/withVFTranslation";

class ForgotPasswordCard extends Component {

  constructor(props){
    super(props);

    this.state = {
      email: '',
      showNoPwdReset: false,
      passwordResetSuccess: false
    }
  }
  
  componentDidMount() {
    if(this.props.onRef) {
      this.props.onRef(this);
    }
    
    let { email } = this.props;

    this.setState({email : email || ''}, () => {
      this.doNextButtonClicked();
    })
  }

  componentWillUnmount() {
    if(this.props.onRef) {
      this.props.onRef(undefined);
    }
  }
  
  validateForm() {
    let { email } = this.state;

    this.props.setValidationErrors([]);
    if(!validateEmail(email)){
      this.props.emailCardRef.triggerValidationErr();
      return false;
    }
    else{
      return true;
    }
  }
  
  doNextButtonClicked(){
    let { email } = this.state;
    let { setStep, setEmailFieldVisible, t } = this.props;

    if(!this.validateForm()){
      return;
    }

    this.props.setLoading(true);
    api.PasswordReset.post(email)
      .then((res) => {
        log.log('pwd reset', res);
        this.props.setLoading(false);
        if (!res.data.disabled_flag) {
          if (res.data.tfa_flag) {
            //password reset is enabled, but tfa is on.  do that first.
            setStep(c.authSteps.tfaPwdReset);
          }
          else{
            //success
            setEmailFieldVisible(false);
            this.props.setHideAuthButtonControls(true);
            this.setState({
              passwordResetSuccess : true,
            })
          }
        }
        else{
          //password reset is disabled, show something scary
          this.props.setHideAuthButtonControls(true);
          this.setState({
            showNoPwdReset: true,
          })
        }
      })
      .catch((err) => {
        this.props.setValidationErrors([
          getMessageForError(err, t)
        ])
        this.props.setLoading(false);
      })
  }

  onEmailChange(evt){
    this.setState ({
      email: evt.target.value
    })
  }
  
  onStartOverButtonClick(evt){
    let { setStep, setEmailFieldVisible } = this.props;

    setEmailFieldVisible(true);
    setStep(c.authSteps.password)
  }

  render() {
    let { showNoPwdReset, passwordResetSuccess } = this.state;
    let { email, isLoading, step, t } = this.props;

    if(isLoading){
      return (
        <div className="pt-3 pb-3">
          <Loading centered color={'light'} size={'sm'}/>
        </div>
      )
    }

    let card = null;
    if(showNoPwdReset){
      card =
        <div className={'light-color'}>
          <h3>{t("Unable to Reset Password")}</h3>
          <p>
            {t("Password reset has been disabled for")} {email}{t(".")}
          </p>
          <hr className={'light-border'} />
          <div className={'text-center'}>
            <Button className="btn btn-link light-color"
                    disabled={this.props.isLoading}
                    onClick={() => this.props.doStartOverButtonClick()}>{t("Start Over")}</Button>
          </div>
        </div>
    }
    else if(passwordResetSuccess){
      card =
        <div className={'light-color text-center'}>
          <h3>{t("Check your Email")}</h3>
          <p>
            {t("We sent an email to")} <br/><b>{email}</b><br/> {t("to make sure you are you.")}
          </p>
          <hr className={'light-border'} />
          <div className={'text-center'}>
            <Button className="btn btn-link light-color"
                    disabled={this.props.isLoading}
                    onClick={() => this.props.doStartOverButtonClick()}>{t("Start Over")}</Button>
          </div>
        </div>
    }
    else{
      card =
        <div>
          {/*<div className={'row'}>*/}
            {/*<div className={'col'}>*/}
              {/*<div className="form-group">*/}
                {/*<FancyInput onRef={ref => (this.emailField = ref)}*/}
                            {/*placeholder={'Email'}*/}
                            {/*inputDisabled={false}*/}
                            {/*fieldType={'email'}*/}
                            {/*isValid={!validationErr}*/}
                            {/*inputValue={this.state.email}*/}
                            {/*onEnter={this.doReset.bind(this)}*/}
                            {/*onChange={this.onEmailChange.bind(this)}/>*/}
              {/*</div>*/}
            {/*</div>*/}
          {/*</div>*/}
        </div>
    }

    return (
      <div>
        {card}
      </div>
    );
  }
}

ForgotPasswordCard.propTypes = {
  onRef : PropTypes.func,
  setLoading : PropTypes.func.isRequired,
  setValidationErrors : PropTypes.func.isRequired,
  setHideAuthButtonControls : PropTypes.func.isRequired,
  doStartOverButtonClick : PropTypes.func.isRequired,
  isLoading : PropTypes.bool.isRequired,
  emailCardRef : PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    email : state.auth.email,
    step : state.auth.step,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setStep: step => dispatch(authActions.setNextStep(step)),
    setEmailFieldVisible : isVisible => dispatch(authActions.setEmailFieldVisible(isVisible))
  };
};

export default withVFTranslation()(connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordCard));
